<script>
  import Files from './Files.svelte';
  import { createEventDispatcher } from 'svelte';
  const dispatch = createEventDispatcher();
  export let title = 'Participant Documents';
</script>

<Files {title} on:close={() => dispatch('close')} /> 